import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { EmpassetComponent } from '../empasset/empasset.component';
import { EmpdocumentComponent } from '../empdocument/empdocument.component';
import { EmppayComponent } from '../emppay/emppay.component';
import { EmpskillsComponent } from '../empskills/empskills.component';
import { ComponentCanDeactivate } from '../PendingChangesGuard ';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {

  constructor() {
 
    
  }
  ngOnInit() {
    
  }

  
}
